module.exports = __webpack_public_path__ + "static/other/gameWarehouse.925bdf18.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameWarehouse.json
// module id = 2400
// module chunks = 0